<template>
  <div class="text-left pt-4">
    <h5>CREAR EMPRESA </h5>
    <p>Aqui podra dar de alta empresas</p>
  </div>
  <hr class="custom-hr my-3" />
  <div>
    <div class="container container-fluid">
      <div class="row">
        <div class="col-md-3">
          <label for="name" class="form-label text-left">Nombre</label>
          <input type="text" class="form-control" id="name" v-model="name" />
        </div>
        <div class="col-md-3">
          <label for="email" class="form-label text-left">Email</label>
          <input type="email" class="form-control" id="email" v-model="email" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div v-for="(email, index) in optionalEmails" :key="index">
            <label :for="'emailOptional_' + index" class="form-label text-left">Otro Email (Opcional)</label>
            <input :id="'emailOptional_' + index" type="email" class="form-control" v-model="optionalEmails[index]" />
          </div>

          <button @click="addOptionalEmail" class="btn btn-secondary my-3">Agregar otro Email</button>

          <div>
            <label for="logo" class="form-label text-sm-center">Logo</label>
            <input
              type="file"
              accept="image/jpeg, image/png, image/jpg"
              class="form-control inputfile"
              id="logo"
              @change="handleLogoChange"
            />
          </div>

          <div class="btn tbn-block btn-custom mt-3" v-if="logo" @click="openImageModal(logo)">Ver Imagen</div>

          
        </div>
        <hr class="custom-hr my-4" />
      </div>
    </div>
  </div>
  
  <!-- MODAL -->
  <ShowImagesModal
    :modalId="'imageModalLogoCompany'"
    :currentImage="currentImage"
    :currentImageName="currentImageName"
  />
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import ShowImagesModal from '../../../components/modals/ShowImages';
import { sharedState } from '../../../Utils/StoreAsignacion';

export default {
  name: 'FormPrincipalCompany',
  emits: ['datosPrincipales'],
  components: {
    ShowImagesModal,
  },
  setup(_, { emit }) {
    const datosPrincipales = ref(null);
    const name = ref(null);
    const email = ref(null);
    const optionalEmails = ref([]);
    const logo = ref(null);
    const currentImage = ref(null);
    const currentImageName = ref('');

    const addOptionalEmail = () => {
      optionalEmails.value.push(null);
    };

    const handleLogoChange = (event) => {
      const file = event.target.files[0];
      logo.value = file;
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalLogoCompany').modal('show');
    };

    const dataMain = () => {
      const data = {
        name: name.value,
        email: email.value,
        optionalEmails: optionalEmails.value,
        logo: logo.value,
      };

      datosPrincipales.value = data;
      emit('datosPrincipales', data);
    };

    onMounted(() => {
      dataMain();
    });

    watch([name, email, optionalEmails, logo], () => {
      dataMain();
    });

    return {
      name,
      email,
      optionalEmails,
      logo,
      currentImage,
      currentImageName,
      openImageModal,
      addOptionalEmail,
      handleLogoChange,
    };
  },
};
</script>
